module.exports = __webpack_public_path__ + "img/goose2.4c1d33bf.jpg";